

export default {
    updateUserData: function (user) {
        return {
            type: 'USER_DATA_RECEIVED',
            user
        };
    }
};
